import { AdminLayout } from "@/views/layouts/AppLayout";
import { ConsignmentPage } from "@/views/pages/productManagement/ConsignmentPage";
import { ConsignmentDetailPage } from "@/views/pages/productManagement/ConsignmentDetailPage";
import { ConsignmentFormPage } from "@/views/pages/productManagement/ConsignmentFormPage";
import { GroupPurchaseDetailPage } from "@/views/pages/productManagement/GroupPurchaseDetailPage";
import { GroupPurchaseFormPage } from "@/views/pages/productManagement/GroupPurchaseFormPage";
import { GroupPurchasePage } from "@/views/pages/productManagement/GroupPurchasePage";
import { BargainDetailPage } from "@/views/pages/productManagement/BargainDetailPage";
import { BargainFormPage } from "@/views/pages/productManagement/BargainFormPage";
import { BargainPage } from "@/views/pages/productManagement/BargainPage";
import type { AdminRouteObject } from "../index";

/** 商品管理路由，先迁移寄售商品列表并保留历史隐藏入口。 */
export const productManagementRoutes: AdminRouteObject = {
    path: "/productManagement",
    element: <AdminLayout />,
    handle: { title: "商品管理" },
    children: [
        {
            path: "consignment",
            element: <ConsignmentPage />,
            handle: {
                title: "寄售商品管理",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "consignment/add",
            element: <ConsignmentFormPage />,
            handle: { title: "新增寄售商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "consignment/edit",
            element: <ConsignmentFormPage />,
            handle: { title: "编辑寄售商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "consignment/detail",
            element: <ConsignmentDetailPage />,
            handle: {
                title: "寄售商品详情",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "consignment/audit",
            element: <ConsignmentDetailPage />,
            handle: { title: "审核寄售商品", permissions: ["ROLE_PRODUCT_MANAGE"] }
        },
        {
            path: "groupPurchase",
            element: <GroupPurchasePage />,
            handle: {
                title: "团购商品管理",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "groupPurchase/detail",
            element: <GroupPurchaseDetailPage />,
            handle: {
                title: "团购商品详情",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "groupPurchase/add",
            element: <GroupPurchaseFormPage />,
            handle: { title: "新增团购商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "groupPurchase/edit",
            element: <GroupPurchaseFormPage />,
            handle: { title: "编辑团购商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "groupPurchase/audit",
            element: <GroupPurchaseDetailPage />,
            handle: { title: "审核团购商品", permissions: ["ROLE_PRODUCT_MANAGE"] }
        },
        {
            path: "bargain",
            element: <BargainPage />,
            handle: {
                title: "捡漏商品管理",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "bargain/detail",
            element: <BargainDetailPage />,
            handle: {
                title: "捡漏商品详情",
                permissions: ["ROLE_PRODUCT_R", "ROLE_PRODUCT_MANAGE", "ROLE_PRODUCT_DEAL", "ROLE_PRODUCT_CLOSE"]
            }
        },
        {
            path: "bargain/add",
            element: <BargainFormPage />,
            handle: { title: "新增捡漏商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "bargain/edit",
            element: <BargainFormPage />,
            handle: { title: "编辑捡漏商品", permissions: ["ROLE_PRODUCT_DEAL"] }
        },
        {
            path: "bargain/audit",
            element: <BargainDetailPage />,
            handle: { title: "审核捡漏商品", permissions: ["ROLE_PRODUCT_MANAGE"] }
        }
    ]
};

export default productManagementRoutes;
